import React from 'react';
import { Typography, CardMedia, Grid } from '@material-ui/core';

const data = (
<Typography component="div">
  <h1>Real Time Concurrent Controller</h1>

  <h2>Objective</h2>
  <p>
  The incentive for this coursework is to understand Real-time operating system (RTOS) and how to use it to write concurrent time-critical applications. In this project, we are required to
  <ul>
    <li>Implement a step motor PID controller with given speed and distance.</li>
    <li>Generate melody by change PWM period of the PID controller</li>
    <li>Mining SHA-256 hashes at exact rate of 5000 nonces per second</li>
  </ul>
  </p>

  <h2>Architecture Overview</h2>
  <img src={require('./archOverview.png')} width="600" /><br/>
  <p>
    For details about the design and evaluation, please view the report attached below.
  </p>


  <h2>Outcome</h2>
  <p>
   We received an A which is the highest grade possible for this project. <br/>
   In term of personal development, I learned more about scheduling and concurrency control such as semaphore and mutex.
  </p>

</Typography>
)
export default data